import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({
  name: 'sensorstationsUrl',
  standalone: false,
})
export class SensorstationsUrlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  public transform(url: string | SafeResourceUrl): SafeResourceUrl {
    return typeof url === 'string'
      ? this.sanitizer.bypassSecurityTrustResourceUrl(url)
      : url;
  }
}
